import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { sortBy } from 'lodash'

import { STRIPE_SETUP } from 'modules/App/components/Header'
import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useListenUserProfileQuery } from 'modules/Users/userApi'
import {
  useListenProductPricingQuery,
  useListenCouponsQuery,
  useListenStripeProductIdQuery,
  useListenProductCurrencyQuery,
} from '../productInfoApi'

import { AlertProvider } from 'common/components/Alert/context'
import { useAlert } from 'common/components/Alert/hooks/useAlert'

import PricingList from '../components/PricingList/PricingList'
import ProductLayout from '../layouts/ProductLayout'

export default function Pricing() {
  const { createAlert } = useAlert()
  const navigate = useNavigate()
  const { userId } = useAuth()

  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''

  const { data: plansData } = useListenProductPricingQuery({ coachOrgId })
  const productPlansLoading = plansData === undefined || plansData?.isLoading
  const productPlans = productPlansLoading || !plansData ? {} : plansData
  const sortedProductPlans = sortBy(productPlans, (plan) => plan.idx)

  const { data: stripeProductId } = useListenStripeProductIdQuery({ coachOrgId })
  const stripeProductIdLoading = stripeProductId === undefined || stripeProductId?.isLoading
  // Prefetch coupons for pricing form
  const { data: coupons } = useListenCouponsQuery({ coachOrgId })
  const couponsLoading = coupons === undefined || coupons?.isLoading
  const { data: currencyData } = useListenProductCurrencyQuery({ coachOrgId })
  const currencyLoading = currencyData === undefined || currencyData?.isLoading

  const isLoading = productPlansLoading || couponsLoading || stripeProductIdLoading || currencyLoading

  useEffect(() => {
    if (!isLoading && !stripeProductId) {
      createAlert({ text: 'Please create Stripe product first', type: 'danger' })
      navigate(STRIPE_SETUP)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, stripeProductId])

  return (
    <AlertProvider>
      <ProductLayout>
        <div className='mt-12 max-w-3xl bg-white rounded-xl'>
          <PricingList coachOrgId={coachOrgId} coupons={coupons} plans={sortedProductPlans} loading={isLoading} />
        </div>
      </ProductLayout>
    </AlertProvider>
  )
}
